module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressbar'), _vm._v(" "), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [_c('drugSelection'), _vm._v(" "), (_vm.showWeb) ? _c('drugInfoWeb', {
    on: {
      "closetab": _vm.closetab
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('bottom-buttons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69e80e28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DrugInfo.vue
// module id = 1496
// module chunks = 1